if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.viewer = this.querySelector('.product-gallery__viewer');
        this.images = Array.from(this.querySelectorAll('.product-gallery__image'));
        this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
        this.settling = false;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', this.onThumbClick.bind(this));
        });

        if (this.images.length > 1) {
          this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            root: this.viewer,
            threshold: 0.6,
          });
          this.images.forEach((image) => this.observer.observe(image));
        }
      }

      onThumbClick(evt) {
        const index = Number(evt.currentTarget.dataset.index);
        const target = this.images[index];
        if (!target) return;

        this.settling = true;
        target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        this.setActiveThumb(index);

        clearTimeout(this.settleTimeout);
        this.settleTimeout = setTimeout(() => {
          this.settling = false;
        }, 600);
      }

      onIntersect(entries) {
        if (this.settling) return;

        const visible = entries.find((entry) => entry.isIntersecting);
        if (!visible) return;

        const index = this.images.indexOf(visible.target);
        if (index > -1) this.setActiveThumb(index);
      }

      setActiveThumb(index) {
        this.thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('product-gallery__thumb--active', i === index);
        });
      }
    }
  );
}
